import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import FooterBar from "../components/FooterBar";

export default function Home() {
  //   const navigate = useNavigate();
  // State for newsletter form message
  const [message, setMessage] = useState("");
  const [isNavActive, setIsNavActive] = useState(false);
  const [activeLink, setActiveLink] = useState("hero");

  // Hamburger menu toggle logic
  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };

  // Close mobile nav when a link is clicked
  const handleNavLinkClick = () => {
    setIsNavActive(false);
  };

  // Form submission logic (simulated API call)
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // For example:
    fetch("/users/subscribe", {
      method: "POST",
      body: JSON.stringify({ email: e.target.email.value }),
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        console.log("response ", response);
        if (response.ok) {
          setMessage(
            "¡Gracias por suscribirte! Te notificaremos cuando la app esté disponible.",
          );
        } else {
          setMessage("Hubo un error al suscribirte. Inténtalo de nuevo.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setMessage("Hubo un error de red. Inténtalo de nuevo.");
      });

    e.target.reset();
  };

  // Logic for 2D canvas animation
  useEffect(() => {
    const canvas = document.getElementById("data-canvas");
    if (!canvas) return; // Guard clause
    const ctx = canvas.getContext("2d");
    let width, height;
    const candles = [];

    // Futuristic colors for the candles and moving average
    const upCandleColor = "rgba(0, 255, 255, 0.7)"; // Cyan with transparency
    const downCandleColor = "rgba(255, 0, 255, 0.7)"; // Magenta with transparency
    const movingAverageColor = "#FFFF00"; // Yellow for the moving average line
    const bollingerBandColor = "rgba(0, 255, 255, 0.3)"; // Cyan with transparency for the bands

    // Configuration for the chart
    const CANDLE_WIDTH = 12;
    const CANDLE_SPACING = 8;
    const PRICE_LIMIT = 0.45;

    let lastCandleCloseY;
    // const MOVING_AVERAGE_PERIOD = 20;
    const BOLLINGER_PERIOD = 20;
    const BOLLINGER_DEVIATIONS = 2;

    const maPoints = [];
    const upperBandPoints = [];
    const lowerBandPoints = [];

    const words = ["SUMABIT", "$", "₿", "PIFOLD"];

    // Class for the background word particles
    class WordParticle {
      constructor() {
        this.x = Math.random() * width;
        this.y = Math.random() * height;
        this.speed = Math.random() * 0.5 + 0.2;
        this.word = words[Math.floor(Math.random() * words.length)];
        this.fontSize = Math.random() * 10 + 8;
        this.opacity = Math.random() * 0.4 + 0.1;
        this.color = `rgba(0, 255, 255, ${this.opacity})`;
      }

      update() {
        this.x -= this.speed;
        if (this.x < -100) {
          this.x = width;
          this.y = Math.random() * height;
          this.speed = Math.random() * 0.5 + 0.2;
          this.fontSize = Math.random() * 10 + 8;
          this.opacity = Math.random() * 0.4 + 0.1;
          this.color = `rgba(0, 255, 255, ${this.opacity})`;
          this.word = words[Math.floor(Math.random() * words.length)];
        }
      }

      draw() {
        ctx.save();
        ctx.font = `${this.fontSize}px Orbitron`;
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.opacity;
        ctx.shadowColor = this.color;
        ctx.shadowBlur = 5;
        ctx.fillText(this.word, this.x, this.y);
        ctx.restore();
      }
    }

    const wordParticles = [];
    const NUMBER_OF_PARTICLES = 100;

    function resizeCanvas() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
      lastCandleCloseY = height / 2;
    }

    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();

    for (let i = 0; i < NUMBER_OF_PARTICLES; i++) {
      wordParticles.push(new WordParticle());
    }

    // Candle object constructor
    function Candle(x, openY, closeY, highY, lowY) {
      this.x = x;
      this.openY = openY;
      this.closeY = closeY;
      this.highY = highY;
      this.lowY = lowY;
      this.isBullish = closeY < openY;
      this.color = this.isBullish ? upCandleColor : downCandleColor;
      this.opacity = 1;
    }

    Candle.prototype.draw = function () {
      ctx.save();
      ctx.globalAlpha = this.opacity;

      ctx.strokeStyle = this.color;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(this.x + CANDLE_WIDTH / 2, this.highY);
      ctx.lineTo(this.x + CANDLE_WIDTH / 2, this.lowY);
      ctx.stroke();

      ctx.fillStyle = this.color;
      ctx.shadowColor = this.color;
      ctx.shadowBlur = 10;

      const bodyY = Math.min(this.openY, this.closeY);
      const bodyHeight = Math.abs(this.openY - this.closeY);

      if (bodyHeight > 1) {
        ctx.fillRect(this.x, bodyY, CANDLE_WIDTH, bodyHeight);
      } else {
        ctx.beginPath();
        ctx.moveTo(this.x, this.openY);
        ctx.lineTo(this.x + CANDLE_WIDTH, this.openY);
        ctx.stroke();
      }
      ctx.restore();
    };

    // Function to generate new candle
    function generateNewCandle() {
      const openY = lastCandleCloseY;
      let priceChange = (Math.random() - 0.5) * 80;
      const centerLine = height / 2;
      const distanceToCenter = openY - centerLine;
      const biasFactor = 0.05;
      const priceBias = -distanceToCenter * biasFactor;
      let closeY = openY + priceChange + priceBias;
      const minY = height / 2 - height * PRICE_LIMIT;
      const maxY = height / 2 + height * PRICE_LIMIT;
      closeY = Math.min(Math.max(closeY, minY), maxY);
      const highY = Math.min(openY, closeY) - Math.random() * 20;
      const lowY = Math.max(openY, closeY) + Math.random() * 20;
      const newCandle = new Candle(
        width + CANDLE_SPACING,
        openY,
        closeY,
        highY,
        lowY,
      );
      candles.push(newCandle);
      lastCandleCloseY = newCandle.closeY;

      if (candles.length >= BOLLINGER_PERIOD) {
        const closePricesForCalculation = candles
          .slice(-BOLLINGER_PERIOD)
          .map((c) => c.closeY);
        const sum = closePricesForCalculation.reduce((a, b) => a + b, 0);
        const mean = sum / closePricesForCalculation.length;
        const stdDev = Math.sqrt(
          closePricesForCalculation
            .map((y) => Math.pow(y - mean, 2))
            .reduce((a, b) => a + b, 0) / closePricesForCalculation.length,
        );
        const upperBand = mean - stdDev * BOLLINGER_DEVIATIONS;
        const lowerBand = mean + stdDev * BOLLINGER_DEVIATIONS;
        const xPosition = newCandle.x + CANDLE_WIDTH / 2;

        maPoints.push({ x: xPosition, y: mean });
        upperBandPoints.push({ x: xPosition, y: upperBand });
        lowerBandPoints.push({ x: xPosition, y: lowerBand });
      }
    }

    // Generate initial candles to fill the screen
    const initialCandlesCount = Math.floor(
      width / (CANDLE_WIDTH + CANDLE_SPACING),
    );
    for (let i = 0; i < initialCandlesCount; i++) {
      const openY = lastCandleCloseY;
      const priceChange = (Math.random() - 0.5) * 80;
      let closeY = openY + priceChange;
      //   const centerLine = height / 2;
      const minY = height / 2 - height * PRICE_LIMIT;
      const maxY = height / 2 + height * PRICE_LIMIT;
      closeY = Math.min(Math.max(closeY, minY), maxY);
      const highY = Math.min(openY, closeY) - Math.random() * 20;
      const lowY = Math.max(openY, closeY) + Math.random() * 20;
      const x =
        width - (initialCandlesCount - i) * (CANDLE_WIDTH + CANDLE_SPACING);
      const initialCandle = new Candle(x, openY, closeY, highY, lowY);
      candles.push(initialCandle);
      lastCandleCloseY = closeY;

      if (candles.length >= BOLLINGER_PERIOD) {
        const closePricesForCalculation = candles
          .slice(-BOLLINGER_PERIOD)
          .map((c) => c.closeY);
        const sum = closePricesForCalculation.reduce((a, b) => a + b, 0);
        const mean = sum / closePricesForCalculation.length;
        const stdDev = Math.sqrt(
          closePricesForCalculation
            .map((y) => Math.pow(y - mean, 2))
            .reduce((a, b) => a + b, 0) / closePricesForCalculation.length,
        );
        const upperBand = mean - stdDev * BOLLINGER_DEVIATIONS;
        const lowerBand = mean + stdDev * BOLLINGER_DEVIATIONS;
        const xPosition = initialCandle.x + CANDLE_WIDTH / 2;
        maPoints.push({ x: xPosition, y: mean });
        upperBandPoints.push({ x: xPosition, y: upperBand });
        lowerBandPoints.push({ x: xPosition, y: lowerBand });
      }
    }

    // Animation loop
    let animationFrameId;
    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, width, height);

      wordParticles.forEach((particle) => {
        particle.update();
        particle.draw();
      });

      if (
        candles.length === 0 ||
        candles[candles.length - 1].x <
          width - (CANDLE_WIDTH + CANDLE_SPACING) * 1.5
      ) {
        generateNewCandle();
      }

      for (let i = candles.length - 1; i >= 0; i--) {
        const candle = candles[i];
        candle.x -= 0.75;

        if (candle.x < -CANDLE_WIDTH) {
          candles.splice(i, 1);
        } else {
          candle.draw();
        }
      }

      for (let i = maPoints.length - 1; i >= 0; i--) {
        maPoints[i].x -= 0.75;
        upperBandPoints[i].x -= 0.75;
        lowerBandPoints[i].x -= 0.75;

        if (maPoints[i].x < 0) {
          maPoints.splice(i, 1);
          upperBandPoints.splice(i, 1);
          lowerBandPoints.splice(i, 1);
        }
      }

      if (maPoints.length > 1) {
        ctx.strokeStyle = movingAverageColor;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(maPoints[0].x, maPoints[0].y);
        for (let i = 1; i < maPoints.length; i++) {
          ctx.lineTo(maPoints[i].x, maPoints[i].y);
        }
        ctx.stroke();
      }

      if (upperBandPoints.length > 1) {
        ctx.strokeStyle = bollingerBandColor;
        ctx.lineWidth = 2;

        ctx.beginPath();
        ctx.moveTo(upperBandPoints[0].x, upperBandPoints[0].y);
        for (let i = 1; i < upperBandPoints.length; i++) {
          ctx.lineTo(upperBandPoints[i].x, upperBandPoints[i].y);
        }
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(lowerBandPoints[0].x, lowerBandPoints[0].y);
        for (let i = 1; i < lowerBandPoints.length; i++) {
          ctx.lineTo(lowerBandPoints[i].x, lowerBandPoints[i].y);
        }
        ctx.stroke();
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();
    resizeCanvas();

    // Cleanup function for useEffect
    return () => {
      window.removeEventListener("resize", resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  // IntersectionObserver for active menu links
  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach((section) => {
      sectionObserver.observe(section);
    });

    // Cleanup
    return () => {
      sections.forEach((section) => {
        sectionObserver.unobserve(section);
      });
    };
  }, []);

  return (
    <>
      {/* NAVIGATION MENU */}
      <nav className="header-nav">
        <a
          href="#hero"
          className="logo"
          onClick={() => {
            handleNavLinkClick();
            window.scrollTo(0, 0);
          }}
        >
          SUMABIT
        </a>
        <div
          className={`hamburger-menu ${isNavActive ? "open" : ""}`}
          onClick={toggleNav}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={`nav-links ${isNavActive ? "nav-active" : ""}`}>
          <li>
            <a
              href="#benefits"
              className={`nav-link ${activeLink === "benefits" ? "nav-active-link" : ""}`}
              onClick={handleNavLinkClick}
            >
              Beneficios
            </a>
          </li>
          {/* <li><a href="#screenshots" className={`nav-link ${activeLink === 'screenshots' ? 'nav-active-link' : ''}`} onClick={handleNavLinkClick}>Pantallas</a></li> */}
          <li>
            <a
              href="#coming-soon"
              className={`nav-link ${activeLink === "coming-soon" ? "nav-active-link" : ""}`}
              onClick={handleNavLinkClick}
            >
              Lanzamiento
            </a>
          </li>
          <li>
            <NavLink to="/market">Mercados</NavLink>
          </li>
        </ul>
      </nav>

      <header id="hero" className="hero full-screen-section">
        <canvas id="data-canvas"></canvas>
        <div className="container hero-content">
          <h1>SUMABIT</h1>
          {/* <img src={logo} style={{ width: "30%", height: "30%" }} alt="SUMABIT" /> */}
          <h2>La App de trading en criptomonedas que estabas esperando.</h2>
        </div>
      </header>

      <section id="benefits" className="full-screen-section">
        <div className="container">
          <h2>Beneficios Exclusivos</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="icon">
                <i className="fas fa-microchip"></i>
              </div>
              <h3>Análisis Predictivo Impulsado por IA</h3>
              <p>
                Deja de adivinar. Nuestros algoritmos de IA analizan el mercado
                spot 24/7 para hacer operaciones de manera más precisa y
                efectiva.
              </p>
            </div>
            <div className="benefit-item">
              <div className="icon">
                <i className="fas fa-tachometer-alt"></i>
              </div>
              <h3>Ejecución de Órdenes Ultrarrápida</h3>
              <p>
                El tiempo es dinero. Nuestra infraestructura garantiza la
                ejecución de tus órdenes en milisegundos, dándote una ventaja
                competitiva.
              </p>
            </div>
            <div className="benefit-item">
              <div className="icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Interfaz Intuitiva</h3>
              <p>
                Olvídate de las interfaces complicadas. Nuestra app combina un
                diseño minimalista donde puedes gestinar todos tus bots y
                trading de manera intuitiva.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="screenshots" className="full-screen-section">
                <div className="container">
                    <h2>Descubre el Poder de la Interfaz</h2>
                    <p style={{ textAlign: 'center', marginBottom: '2rem' }}>Una experiencia visualmente impactante y fácil de usar, diseñada para el futuro del trading.</p>
                    <div className="screenshots">
                        <div className="screenshot-item">
                            <img src="https://placehold.co/300x550/1A1A2E/00FFFF?text=Dashboard" alt="Dashboard de la app" />
                        </div>
                        <div className="screenshot-item">
                            <img src="https://placehold.co/300x550/1A1A2E/00FFFF?text=Gráficos+Interactivos" alt="Gráficos de trading interactivos" />
                        </div>
                        <div className="screenshot-item">
                            <img src="https://placehold.co/300x550/1A1A2E/00FFFF?text=Órdenes+de+Compra" alt="Pantalla de órdenes de compra y venta" />
                        </div>
                    </div>
                </div>
            </section> */}

      <section id="coming-soon" className="coming-soon full-screen-section">
        <div className="container">
          <h2>El Lanzamiento Está Cerca.</h2>
          <p>
            Prepárate para transformar tu forma de hacer trading. Regístrate
            ahora para ser de los primeros en acceder a la app en su lanzamiento
            y recibir actualizaciones exclusivas.
          </p>
          <div className="app-store-links">
            <a href="#" className="disabled-link">
              <i className="fab fa-google-play"></i> Google Play
            </a>
            <a href="#" className="disabled-link">
              <i className="fab fa-apple"></i> App Store
            </a>
          </div>
          <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Ingresa tu correo electrónico"
              required
            />
            <button type="submit">Suscribirme</button>
          </form>
          <p
            id="message"
            style={{
              visibility: message ? "visible" : "hidden",
              opacity: message ? 1 : 0,
            }}
          >
            {message}
          </p>
        </div>
      </section>

      <FooterBar />
    </>
  );
}
